import React from 'react';
import Dialog from '@material-ui/core/Dialog';
import withMobileDialog from '@material-ui/core/withMobileDialog';
import {
  HeaderGridContainer,
  HeaderTitle,
  HeaderDate,
  Video,
  VideoDialogContainer,
  RightWrap,
  ItemList,
  Item,
  Icon,
  CloseIcon,
  TitleChageIcon,
  HeaderTitleWrap
} from './ShortsDialog.style';
import i18n from '@/i18n';
import dayjs from 'dayjs';
import { SHORTS_RENDER_STATE } from '@/utils/Global';
import Validator from "@/utils/Validator"

class ShortsDialog extends React.Component {
  videoRef

  generateRandomBoolean = () => Math.random() <= 0.15

  onCloseDialog = () => {
    this.props.closeDialog()
  }

  setVideoRef = ref => {
    this.videoRef = ref
  }

  renderItems = () => {
    const {
      renderStateTableData,
      onVideoEditClicked,
      onDownloadClicked,
      openDialog,
      selectedVideo,
      provider = null,
      value
    } = this.props;

    const {
      _id,
      analysisId,
      analysisIndex,
      name,
      isDownloadable,
      isEditable,
      state,
    } = selectedVideo;

    if(!selectedVideo) return;
    const isVideoError = state === SHORTS_RENDER_STATE.ERROR
    let isStoreExpired =  false
    if (provider !== "cafe24") isStoreExpired = Validator.Boolean(selectedVideo.isStoreExpired) ? selectedVideo.isStoreExpired : true
      return (
        <>
          {
            !isStoreExpired && 
            <Item onClick={() => onVideoEditClicked(_id, analysisId, analysisIndex, renderStateTableData, isEditable, isStoreExpired)}>
              <Icon src='https://front.videomonster.com/images-u6yd72dy/web/videoDialog/video_edit.svg' />{i18n.t("VideoDialog.menu.edit") }
            </Item>
          }
          
          {
            !isVideoError &&
            <Item onClick={() => onDownloadClicked(_id, name, isDownloadable)}>
              <Icon src='https://front.videomonster.com/images-u6yd72dy/web/videoDialog/video_download.svg' />{i18n.t("VideoDialog.menu.downloadVideo")}
            </Item>
          }
           <Item onClick={openDialog("ConfirmationDialog", _id, renderStateTableData)}>
            <Icon src='https://front.videomonster.com/images-u6yd72dy/web/videoDialog/video_delete.svg' />{i18n.t("VideoDialog.menu.delete") }
          </Item>
        </>
      )
  }


  renderErrorText = (errorCode)=>{
   switch(errorCode){
    case "0001":
      return i18n.t("VideoDialog.renderVideo.resolution.error");
    case "0002":
      return i18n.t("VideoDialog.renderVideo.file.corrupted.error");
    case "0003":
      return i18n.t("VideoDialog.renderVideo.file.upload.error");
    case "0004":
    default:
      return i18n.t("VideoDialog.renderVideo.render.error");
   }
  }

  renderVideo = () => {
    const {
      url,
      isDownloadable,
      state,
      errorCode
    } = this.props.selectedVideo;
    if (state === SHORTS_RENDER_STATE.ERROR) return this.renderErrorText(errorCode)
    if (!url) {
      return i18n.t("VideoDialog.renderVideo.error");
    }

    if (url === '' || isDownloadable === false) {
      return (
        <div style={{ padding: '40px 130px' }}>
          {i18n.t("VideoDialog.renderVideo.isDownloadable")}
        </div>
      )
    }

    return (
      <>
        <video
          controls
          controlsList="nodownload"
          style={{ margin: '', maxWidth: '100%', height:"100%" }}
          id="movie_injection"
          autoPlay
          ref={this.setVideoRef}
        >
          <source src={`${url}` || ''} type="video/mp4" />
          <source src={`${url}` || ''} type="video/ogg" />
          Your browser does not support the video tag.
        </video>
      </>
    );
  };

  render() {
    if (this.props.selectedVideo === undefined) {
      return null;
    }

    const {
      selectedVideo,
      onChangeTitle
    } = this.props;
    const {
      name,
      date,
    } = selectedVideo;

    return (
      <div>
        <Dialog
          fullScreen={false}
          open={this.props.isDialogOpened}
          onClose={this.onCloseDialog}
          aria-labelledby="responsive-dialog-title"
          maxWidth={"lg"}
          PaperProps={{
            style:{
              overflowY:"hidden"
            }
          }}
        >
          <VideoDialogContainer>
            <Video>{this.renderVideo()}</Video>
            <RightWrap className='scroll'>
              <HeaderGridContainer>
                <HeaderTitleWrap>
                  <HeaderTitle>{name}</HeaderTitle>
                  <TitleChageIcon onClick={() => onChangeTitle(selectedVideo)} src='https://front.videomonster.com/images-u6yd72dy/web/videoDialog/change_title.svg' />
                </HeaderTitleWrap>
                <HeaderDate>{`${dayjs(date).year()}${i18n.t("userinfo.year")} ${dayjs(date).month() + 1}${i18n.t("userinfo.month")} ${dayjs(date).date()}${i18n.t("userinfo.day")}`}</HeaderDate>
                <CloseIcon onClick={this.onCloseDialog} src='https://front.videomonster.com/images-u6yd72dy/web/videoDialog/close_icon.svg' alt='close icon'/>
              </HeaderGridContainer>
              <ItemList >
                {this.renderItems()}
              </ItemList>
            </RightWrap>
          </VideoDialogContainer>
        </Dialog>
      </div>
    );
  }
}

export default withMobileDialog()(ShortsDialog);
